import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../services/api";
import "../styles/admin.css";

function formatarDataHora(valor) {
  if (!valor) return "Data nao informada";
  const data = new Date(valor);

  if (Number.isNaN(data.getTime())) return "Data nao informada";

  return data.toLocaleString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

function labelAcao(acao) {
  const labels = {
    incluiu: "Incluiu",
    editou: "Editou",
    excluiu: "Excluiu",
  };

  return labels[acao] || acao || "Alterou";
}

function AdminReports() {
  const navigate = useNavigate();
  const [relatorios, setRelatorios] = useState([]);
  const [busca, setBusca] = useState("");
  const [erro, setErro] = useState("");
  const [carregando, setCarregando] = useState(false);

  async function carregarRelatorios() {
    setCarregando(true);
    try {
      const response = await api.get("/reports");
      setRelatorios(response.data || []);
      setErro("");
    } catch (error) {
      console.error("Erro ao carregar relatorios:", error);
      setErro(error.response?.data?.message || "Nao foi possivel carregar os relatorios.");
    } finally {
      setCarregando(false);
    }
  }

  useEffect(function () {
    carregarRelatorios();
  }, []);

  const relatoriosFiltrados = useMemo(function () {
    const termo = busca.trim().toLowerCase();
    if (!termo) return relatorios;

    return relatorios.filter((item) => {
      return [
        item.user_name,
        item.user_login,
        item.action,
        item.entity_title,
        item.description,
      ]
        .filter(Boolean)
        .some((valor) => String(valor).toLowerCase().includes(termo));
    });
  }, [busca, relatorios]);

  const totais = useMemo(function () {
    return relatorios.reduce(
      (acc, item) => ({
        ...acc,
        [item.action]: (acc[item.action] || 0) + 1,
      }),
      {}
    );
  }, [relatorios]);

  return (
    <div className="admin-reports-page">
      <div className="admin-reports-shell">
        <header className="admin-reports-header">
          <div>
            <span>Relatorios</span>
            <h1>Historico de alteracoes</h1>
            <p>Veja quem incluiu, editou ou excluiu cards, com data e hora de cada alteracao registrada no banco.</p>
          </div>
          <button type="button" className="admin-report-back" onClick={() => navigate("/admin")}>
            Voltar
          </button>
        </header>

        <section className="admin-report-stats" aria-label="Resumo de alteracoes">
          <article>
            <strong>{relatorios.length}</strong>
            <span>Total</span>
          </article>
          <article>
            <strong>{totais.incluiu || 0}</strong>
            <span>Inclusoes</span>
          </article>
          <article>
            <strong>{totais.editou || 0}</strong>
            <span>Edicoes</span>
          </article>
          <article>
            <strong>{totais.excluiu || 0}</strong>
            <span>Exclusoes</span>
          </article>
        </section>

        <section className="admin-report-toolbar">
          <label>
            Buscar no relatorio
            <input
              type="text"
              value={busca}
              onChange={(e) => setBusca(e.target.value)}
              placeholder="Usuario, login, acao ou card"
            />
          </label>
          <button type="button" onClick={carregarRelatorios} disabled={carregando}>
            {carregando ? "Atualizando..." : "Atualizar"}
          </button>
        </section>

        {erro && <div className="admin-report-error">{erro}</div>}

        <section className="admin-report-timeline">
          {carregando ? (
            <div className="admin-report-empty">Carregando relatorios...</div>
          ) : relatoriosFiltrados.length === 0 ? (
            <div className="admin-report-empty">Nenhuma alteracao encontrada.</div>
          ) : (
            relatoriosFiltrados.map((item) => (
              <article className={`admin-report-item action-${item.action}`} key={item.id}>
                <div className="admin-report-marker" />
                <div className="admin-report-content">
                  <div className="admin-report-topline">
                    <span>{labelAcao(item.action)}</span>
                    <time>{formatarDataHora(item.created_at)}</time>
                  </div>
                  <h2>{item.entity_title || "Registro sem titulo"}</h2>
                  <p>
                    <strong>{item.user_name || "Usuario nao identificado"}</strong>
                    {item.user_login ? ` (${item.user_login})` : ""} {item.description || "realizou uma alteracao"}.
                  </p>
                </div>
              </article>
            ))
          )}
        </section>
      </div>
    </div>
  );
}

export default AdminReports;